
















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch,
  Mixins
} from "vue-property-decorator";
import jsBridge from "@/jsbridge/index";
import { isIos } from "@/utils/lodash";

@Component({
  components: {}
})
export default class BottomGroup extends Vue {
  private loginWithInstragram() {
    if (isIos()) {
      // jsBridge.hideKeyboard().then(() => {
      setTimeout(() => {
        this.$emit("clickToLogin");
      }, 50);
      // });
    } else {
      this.$emit("clickToLogin");
    }
  }
}
